export const SET_ERROR_TYPE = 'SET_ERROR_TYPE';
export const CLEAR_ERROR_TYPE = 'CLEAR_ERROR_TYPE';
export const RESET_ERROR_STATE = 'RESET_ERROR_STATE';
export const SET_SHOULD_SHOW_ERROR_IN_PAGE = 'SET_SHOULD_SHOW_ERROR_IN_PAGE';